import React, { useContext, useState } from "react";
import { ContactContext, EntitySelectorContext as Context } from "./index";
import { updateContactEntitiesDataApi } from "../Api/UpdateContact.js";
import { showContactEntitiesApi } from "../Api/ShowContact.js";
import { getErrorsArrayMessageFromHtttpResponse } from "../../../Shared/Utils/errorUtils.js";

const EntitySelectorProvider = (props) => {
  const [contactEntities, setContactEntities] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);

  //edit item
  const getContactEntities = async (id) => {
    let response = await showContactEntitiesApi(id);

    if (response?.result && response?.result == "success") {
      setContactEntities(response.data); // Actualizar el estado con un nuevo array

      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };
  //edit item
  const updateContactEntities = async (data, id) => {
    let response = await updateContactEntitiesDataApi(data, id);

    if (response?.result && response?.result == "success") {
      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        contactEntities,
        updateContactEntities,
        setContactEntities,
        getContactEntities,
        apiErrors,
        setApiErrors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default EntitySelectorProvider;
